import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

export default class HorizontalLayoutAlign extends BaseOption {
  static userInterfaceComponent = {
    label: "Align",
    component: inspectorTools.RADIO_BAR,
    props: {
      iconSize: 24,
      options: [
        {
          icon: "position-left",
          value: "left",
        },
        {
          icon: "position-middle-horizontal",
          value: "center",
        },
        {
          icon: "position-right",
          value: "right",
        },
        {
          icon: "position-around-horizontal",
          value: "around",
        },
        {
          icon: "position-between-horizontal",
          value: "between",
        },
        {
          icon: "position-evenly-horizontal",
          value: "evenly",
        },
      ],
    },
  };

  static defaultValue = "left";

  static convertConfigValueToCompiledValue(configValue) {
    if (typeof configValue === "string") {
      return configValue;
    }
    if (configValue && configValue.value) {
      return configValue.value;
    }
  }
}
